module.exports = __webpack_public_path__ + "img/Coma_berenices.d77b44d3.png";